import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/shadcn/card';

export default function SuperAdminArenas() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Manajemen Arena</CardTitle>
        <CardDescription>Buat dan kelola arena mitra</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground">Fitur manajemen arena akan segera tersedia.</p>
      </CardContent>
    </Card>
  );
}
